$(document).ready(function(){
	$('.load-more').click(function(e){
		e.preventDefault();

		var label;
		var params_name = $(this).data('params');
		var params = window[params_name];
		var holder = $(params.holder);
		var button = $(this);
		var data = {
	    	'ajaxrequest': true,
			'action': 'loadmore',
			'query': params.posts,
			'page' : params.current_page,
			'item_container': params.item_container,
			'format': params.format
		};

		label = button.html();
		button.text('...').addClass('loading');

		$.ajax({
			url:  '/wp-admin/admin-ajax.php',
			type: 'post',
			data: data
		}).done(function(response){
			if(response){
				button.html(label).removeClass('loading');
				params.current_page++;
				holder.append(response);
				if(params.current_page >= params.max_page) button.remove(); // if last page, remove the button

				reveal();
				// you can also fire the "post-load" event here if you use a plugin that requires it
				$(document.body).trigger('post-load');
			}else{
				button.remove(); // if no data, remove the button as well
			}
		}).fail(function(){
			button.html(label).removeClass('loading');
		});

	});
});
